document.addEventListener('DOMContentLoaded', function() {
  // Email del cliente logueado en Shopify (inyectado desde theme.liquid)
  const extoleEmail = window.candyCustomerEmail || null;

  // Ruta base de la página del programa de referidos
  const referralBasePath = '/pages/referral-program';

  // --- Función helper: abrir Extole según alias ("friend" o "business") ---
  function openExtoleZoneByAlias(alias) {
    if (!extoleEmail) {
      console.warn('No hay email de cliente logueado, no se puede abrir Extole con seguridad.');
      return;
    }

    if (!window.extole) {
      console.warn('Extole no está disponible en window.extole.');
      return;
    }

    // Buscamos el botón correspondiente en la página
    let selector;
    if (alias === 'business') {
      selector = '.cta-button.btn-business';
    } else {
      // Por defecto, usamos "friend"
      selector = '.cta-button.btn-friend';
    }

    const btn = document.querySelector(selector);
    if (!btn) {
      console.warn('No se encontró el botón para alias:', alias);
      return;
    }

    const zoneName = btn.dataset.zone;
    if (!zoneName) {
      console.warn('El botón para alias', alias, 'no tiene data-zone configurado.');
      return;
    }

    const zoneConfig = {
      name: zoneName,
      data: {
        email: extoleEmail
      }
    };

    console.log('Abriendo Extole Zone por alias:', alias, 'config:', zoneConfig);
    window.extole.createZone(zoneConfig);
  }

  // --- 1) Auto-abrir popup después de login, usando ?open_zone_alias=friend|business ---

  const currentUrl = new URL(window.location.href);
  const openZoneAlias = currentUrl.searchParams.get('open_zone_alias');

  if (extoleEmail && openZoneAlias) {
    console.log('Detectado open_zone_alias en URL:', openZoneAlias);
    openExtoleZoneByAlias(openZoneAlias);

    // Limpiar la URL para que no se repita si el usuario recarga
    currentUrl.searchParams.delete('open_zone_alias');
    window.history.replaceState({}, '', currentUrl.toString());
  }

  // --- 2) Lógica de Extole al hacer clic en los botones ---

  const ctaButtons = document.querySelectorAll('.cta-button');

  ctaButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault(); // Evitar salto de link

      const zoneName = btn.dataset.zone;
      console.log('Botón clickeado. zoneName:', zoneName, 'clases:', btn.className);

      // Determinar alias según el tipo de botón
      const isBusiness = btn.classList.contains('btn-business');
      const alias = isBusiness ? 'business' : 'friend';

      // 2.1) Si NO hay usuario logueado en Shopify → exigir login y recordar alias
      if (!extoleEmail) {
        // return_to incluirá solo el alias (friend|business), no el zoneName completo
        const returnTo = referralBasePath + '?open_zone_alias=' + encodeURIComponent(alias);

        const loginUrl =
          '/customer_authentication/login?return_to=' + encodeURIComponent(returnTo);

        console.log('No hay cliente logueado. Redirigiendo a login:', loginUrl);
        window.location.href = loginUrl;
        return;
      }

      // 2.2) Si SÍ hay usuario logueado y Extole está cargado → abrir popup directamente
      if (window.extole) {
        if (!zoneName) {
          console.warn('El botón clickeado no tiene data-zone configurado.');
          return;
        }

        const zoneConfig = {
          name: zoneName,
          data: {
            email: extoleEmail
          }
        };

        console.log('Disparando Extole Zone con config (click directo):', zoneConfig);
        window.extole.createZone(zoneConfig);
      } else {
        console.warn('Extole no detectado.');
        // Fallback opcional:
        // window.location.href = referralBasePath;
      }
    });
  });
  // --- NUEVO: Lógica de Smooth Scroll para el botón del Banner ---
  const scrollBannerBtn = document.getElementById('scroll-to-cards-btn');
  const cardsSection = document.getElementById('referral-cards-section');

  if (scrollBannerBtn && cardsSection) {
    scrollBannerBtn.addEventListener('click', function(e) {
      e.preventDefault(); // Evita que la página salte bruscamente
      
      // Hace un scroll suave hacia el contenedor de las tarjetas
      cardsSection.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' // Alinea la parte superior de las tarjetas con la pantalla
      });
    });
  }
});